var _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSh = function SvgSh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "sh_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v30h60V0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "sh_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15h30v15zv15H0zH0V0zV0h30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sh_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0v30h60V0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 6,
    d: "m0 0 60 30m0-30L0 30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    strokeWidth: 4,
    d: "m0 0 60 30m0-30L0 30",
    clipPath: "url(#sh_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "M30 0v30M0 15h60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    strokeWidth: 6,
    d: "M30 0v30M0 15h60"
  }))));
};
export default SvgSh;